<template>
<!-- 常见问题=非现场维修 -->
    <div class="maintain">
        <p>非现场维护、邮寄时注意事项</p>
        <p>收件单位:加加明售后中心</p>
        <p>收件人:郭芳</p>
        <p>联系电话:(010)82057855</p>
        <p>收件地址:北京市通州区永乐店经济开发区联东U谷产业园，恒业七街6号院1号楼302室.</p>
        <p>*邮寄时，附纸写明*</p>
        <p>姓名、电话、地址、产品编号、购买日期、详细反馈问题及要求.</p>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style>
body {
    background: #f8f8f8f8;
}
p {
    margin: 0;
    padding: 0;
}
.maintain {
    background: #ffffff;
    border-radius: 25px;
    padding: 28px;
    margin: 28px;
    font-size: 40px;
    letter-spacing: 5px;
    color: #333333;
}

.maintain p {
    line-height: 60px;
}

.maintain p:first-of-type {
    font-weight: 700;
    text-align: center;
    margin-bottom: 60px;
}

.maintain p:nth-of-type(5) {
    margin-bottom: 72px;
}

.maintain img {
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/views/Maintain.vue